import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import ENUMS from '../../enums';
import { formatter, enumHelper } from '../../utils';
import { connect } from 'react-redux';
import DeleteConfirm from '../../components/DeleteConfirm';

import './userTable.scss';
import generateClassName from '../../utils/generateClassName';
class UserTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayDeleteConfirm: false,
      selectedItemKeyForDelete: null,
      sortType: 'asc',
      sortedColumn: ''
    };
  }

  renderStatus = status => {
    switch (status) {
      case 'PENDING':
        return 'badge-warning';
      case 'ACTIVATED':
        return 'badge-success';
      case 'BANNED':
        return 'badge-danger';
      default:
        break;
    }
  };

  sortTable = query => {
    this.setState({ sortedColumn: query });
    this.props.sortTable(query);
  };

  routeToEditUser = user => {
    return this.props.history.push({
      pathname: '/users/edit',
      state: { id: user.id }
    });
  };
  deleteAlreadySelectedItem = () => {
    this.setState(() => ({
      selectedItemKeyForDelete: null,
      displayDeleteConfirm: false
    }));
  };
  closeDeleteTableItemModal = () => {
    this.setState(() => ({
      selectedItemKeyForDelete: null,
      displayDeleteConfirm: false
    }));
  };
  render() {
    let { usersList, pageNumber, pageSize, sortType } = this.props;
    return (
      <React.Fragment>
        <table className="table table-hover table-striped table-light col-12">
          <thead className="thead-dark">
            <tr>
              <th className="text-center"></th>
              <th className="text-center">{locales('tables.row')}</th>
              <th onClick={() => this.sortTable('fullName')} className="text-center pointer">
                <i
                  name="fullName"
                  className={generateClassName('fullName', this.state.sortedColumn, sortType)}
                />
                {locales('tables.fullName')}
              </th>
              <th onClick={() => this.sortTable('userName')} className="text-center pointer">
                <i
                  name="userName"
                  className={generateClassName('userName', this.state.sortedColumn, sortType)}
                />
                {locales('messages.username')}
              </th>
              <th onClick={() => this.sortTable('mobileNumber')} className="text-center pointer">
                <i
                  name="mobileNumber"
                  className={generateClassName('mobileNumber', this.state.sortedColumn, sortType)}
                />
                {locales('fields.mobileNumber')}
              </th>
              <th onClick={() => this.sortTable('mobileNumber')} className="text-center pointer">
                <i
                  name="cityName"
                  className={generateClassName('cityName', this.state.sortedColumn, sortType)}
                />
                {locales('tables.cityName')}
              </th>
              <th className="text-center">{locales('tables.status')}</th>
              <th onClick={() => this.sortTable('credit')} className="text-center pointer">
                <i name="credit" className={generateClassName('credit', this.state.sortedColumn, sortType)} />
                {`${locales('tables.credit')} (${
                  ENUMS.MONEY_UNITS.list.filter(
                    moneyUnit => (usersList.length && moneyUnit.value == usersList[0].currency) || 'TOMAN'
                  )[0].title
                })`}
              </th>
              <th onClick={() => this.sortTable('totalReserves')} className="text-center pointer">
                <i name="totalReserves" className="px-1 text-muted align-middle text-center fas fa-sort-down" />
                {locales('titles.totalReserves')}</th>
              <th onClick={() => this.sortTable('createdAt')} className="text-center pointer">
                <i name="createdAt" className="px-1 text-muted align-middle text-center fas fa-sort-down" />
                {locales('tables.creationDate')}
              </th>
              <th className="text-center"></th>
              <th className="text-center"></th>
            </tr>
          </thead>
          <tbody>
            {usersList.length ? (
              usersList.map((user, index) => (
                <tr key={index}>
                  <td className="text-center ">
                    <img
                      className="user-default-image"
                      src={user.avatarUrl ? user.avatarUrl : require('../../assets/icons/userDefault.png')}
                      alt="user"
                    />
                  </td>
                  <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                  <td className="text-center">{`${user.fullName}`}</td>
                  <td className="text-center">{user.userName}</td>
                  <td className="text-center">{user.mobileNumber}</td>
                  <td className="text-center">{user.cityName}</td>
                  <td className="text-center">
                    <span className={`badge ${this.renderStatus(user.status)} p-1`}>
                      {enumHelper.convertEnumValueToTitle(ENUMS.USER_STATUS.list, user.status)}
                    </span>
                  </td>
                  <td className="text-center">{formatter.numberWithCommas(user.credit)}</td>
                  <td className="text-center">{user.totalReserves}</td>
                  <td className="text-center">{user.createdAt}</td>
                  <td
                    title={locales('titles.editUser')}
                    onClick={event => event.stopPropagation()}
                    className="text-center"
                  >
                    <NavLink
                      to={{
                        pathname: '/users/edit',
                        userId: user.id,
                        editMode: true
                      }}
                    >
                      <i className="fal fa-pencil-alt pointer text-muted"></i>
                    </NavLink>
                  </td>
                  <td onClick={event => event.stopPropagation()} className="text-center">
                    <NavLink
                      to={{
                        pathname: '/users/details',
                        state: { id: user.id },
                        editMode: true
                      }}
                    >
                      <i className="text-center fal fa-users-class text-success pointer" />
                    </NavLink>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="col-12 text-center">
                <td className="alert alert-info" colSpan={12}>
                  {locales('alerts.noRecord')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {this.state.displayDeleteConfirm && (
          <DeleteConfirm
            isOpen={this.state.displayDeleteConfirm}
            itemGroupTitle={locales('titles.user')}
            itemKey={this.state.selectedItemKeyForDelete}
            itemTitle={this.state.selectedItemTitleForDelete}
            onConfirm={this.deleteAlreadySelectedItem}
            closeModal={this.closeDeleteTableItemModal}
          />
        )}
      </React.Fragment>
    );
  }
}
UserTable.defaultProps = {
  usersList: [
    {
      userName: '---',
      imageUrl: null,
      mobileNumber: '---',
      status: 'PENDING',
      fullName: '---'
    }
  ]
};
UserTable.propTypes = {
  usersList: PropTypes.arrayOf(
    PropTypes.shape({
      userName: PropTypes.string,
      fullName: PropTypes.string,
      mobileNumber: PropTypes.string,
      status: PropTypes.string,
      createdAt: PropTypes.string,
      totalReserves: PropTypes.string,
      imageUrl: PropTypes.string,
      id: PropTypes.number
    })
  )
};
const mapStateToProps = state => {
  return {
    usersList: state.userReducer.usersList || []
  };
};
export default withRouter(connect(mapStateToProps)(UserTable));
